/* eslint react/button-has-type: 0 */
import React from 'react';
import PropTypes from 'prop-types';
import omit from 'lodash/omit';

import './style.css';

const Button = (props) => {
  const { type, className, theme, children } = props;
  const otherProps = omit(props, ['type', 'className', 'theme', 'children']);

  return (
    <button
      type={type}
      className={`c-button -${theme} ${className}`}
      {...otherProps}
    >
      {children}
    </button>
  );
};

Button.propTypes = {
  type: PropTypes.string,
  className: PropTypes.string,
  theme: PropTypes.oneOf(['primary', 'secondary']),
  children: PropTypes.node.isRequired
};

Button.defaultProps = {
  type: 'button',
  className: '',
  theme: 'primary'
};

export default Button;



// WEBPACK FOOTER //
// ./src/components/button/index.js